import {
  Checkbox,
  Collapse,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { MIN_SEARCH_LENGTH } from '../../../utils/searchConstants';
import { ClearFiltersButton } from '../../common/components';
import type { ContactType } from '../../../types/contact';

interface ContactFiltersProps {
  show: boolean;
  filterName: string;
  onFilterNameChange: (value: string) => void;
  filterPhone: string;
  onFilterPhoneChange: (value: string) => void;
  filterType?: ContactType;
  onFilterTypeChange?: (value: ContactType | undefined) => void;
  showOnlyActive?: boolean;
  onShowOnlyActiveChange?: (value: boolean) => void;
  onClearFilters: () => void;
}

export const ContactFilters = ({
  show,
  filterName,
  onFilterNameChange,
  filterPhone,
  onFilterPhoneChange,
  filterType,
  onFilterTypeChange,
  showOnlyActive,
  onShowOnlyActiveChange,
  onClearFilters,
}: ContactFiltersProps) => {
  return (
    <Collapse in={show}>
      <Paper sx={{ p: 2, mb: 2, backgroundColor: 'background.default' }} variant="outlined">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <TextField
            label="Пошук за ім'ям"
            variant="outlined"
            size="small"
            fullWidth
            value={filterName}
            onChange={(e) => onFilterNameChange(e.target.value)}
            helperText={filterName.length > 0 && filterName.length < MIN_SEARCH_LENGTH ? `Введіть щонайменше ${MIN_SEARCH_LENGTH} символів для пошуку` : ' '}
            sx={{ flexGrow: 1 }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: filterName && (
                  <InputAdornment position="end">
                    <Tooltip title="Очистити">
                      <IconButton size="small" onClick={() => onFilterNameChange('')}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              },
            }}
          />
          <TextField
            label="Пошук за телефоном"
            variant="outlined"
            size="small"
            fullWidth
            value={filterPhone}
            onChange={(e) => onFilterPhoneChange(e.target.value)}
            helperText={filterPhone.length > 0 && filterPhone.length < MIN_SEARCH_LENGTH ? `Введіть щонайменше ${MIN_SEARCH_LENGTH} символів для пошуку` : ' '}
            sx={{ flexGrow: 1 }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: filterPhone && (
                  <InputAdornment position="end">
                    <Tooltip title="Очистити">
                      <IconButton size="small" onClick={() => onFilterPhoneChange('')}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              },
            }}
          />
          {onFilterTypeChange && (
            <TextField
              select
              label="Тип"
              variant="outlined"
              size="small"
              fullWidth
              value={filterType ?? ''}
              onChange={(e) => onFilterTypeChange((e.target.value || undefined) as ContactType | undefined)}
              helperText=" "
              sx={{ flexGrow: 1 }}
              slotProps={{
                select: { displayEmpty: true },
                inputLabel: { shrink: true },
              }}
            >
              <MenuItem value="">Усі</MenuItem>
              <MenuItem value="CLIENT">Клієнти</MenuItem>
              <MenuItem value="PROVIDER">Постачальники</MenuItem>
            </TextField>
          )}
        </Stack>
        {onShowOnlyActiveChange && (
          <FormControlLabel
            control={(
              <Checkbox
                checked={showOnlyActive ?? true}
                onChange={(e) => onShowOnlyActiveChange(e.target.checked)}
              />
            )}
            label="Показувати лише активні"
            sx={{ mt: 1, ml: 0 }}
          />
        )}
        {(filterName || filterPhone || filterType) && (
          <ClearFiltersButton onClick={onClearFilters} />
        )}
      </Paper>
    </Collapse>
  );
};
